
export const permissionType = {
  noSpecialPermission: 'no special permission',
  canViewAdminPage: 'canViewAdminPage',
  canViewOnsiteAdminPage: 'canViewOnsiteAdminPage',
  canModifySite: 'canModifySite',
  canViewRegistration: 'canViewRegistration',
  canEditBidderName: 'canEditBidderName',
  canConfigureSite: 'canConfigureSite',
  canViewTitleStats: 'canViewTitleStats',
  canViewItemAssetTitleDetails: 'canViewItemAssetTitleDetails',
  canManageTitle: 'canManageTitle',
  canPrintCoverSheet: 'canPrintCoverSheet',
  canPrintForms: 'canPrintForms',
  canSendReminderEmail: 'canSendReminderEmail',
  canManageFormsTemplates: 'canManageFormsTemplates',
  canInspect: 'canInspect',
  canGate: 'canGate',
  canReviewInspection: 'canReviewInspection',
  canInspectAtYard: 'canInspectAtYard',
  canManageYard: 'canManageYard',

  canViewAssetPackage: 'canViewAssetPackage',
  canCreateEditAssetPackage: 'canCreateEditAssetPackage',
  canCreateEditContractedAssets: 'canCreateEditContractedAssets',
  canMoveSoldRBAsset: 'canMoveSoldRBAsset',
  canMoveSoldIPAsset: 'canMoveSoldIPAsset',
  canUpdateAssetSalesInfo: 'canUpdateAssetSalesInfo',
  canUpdateAssetLienInfo: 'canUpdateAssetLienInfo',
  canSendAssetToContractReady: 'canSendAssetToContractReady',
  canSendAssetToOperations: 'canSendAssetToOperations',
  canReconsignAsset: 'canReconsignAsset',
  canCollapseAssetToInventory: 'canCollapseAssetToInventory',
  canDeleteAsset: 'canDeleteAsset',
  canDuplicateAsset: 'canDuplicateAsset',
  canMergePackages: 'canMergePackages',
  canSendAssetPackageToPricing: 'canSendAssetPackageToPricing',
  canMoveAsset: 'canMoveAsset',
  canAccessAssetEditor: 'canAccessAssetEditor',
  canListEquipmentForUsers: 'canListEquipmentForUsers',
  canManageChecklists: 'canManageChecklists',
  canModifyEquipmentDetails: 'canModifyEquipmentDetails'
};




